import {
    Box
} from "@pankod/refine-mui";

export const Footer: React.FC = () => {
    return (
        <Box sx={{
            height: "64px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: {
                xs: "12px",
                md: "14px"
            }
        }}>
            Welcome to streamer studio
        </Box>
    );
};
